// List of allowed domains
export const allowedDomains = [
  'financial-money.com', 
  'findyourfit.net', 
  'alcatrazblog.com', 
  'template.com', 
  'secretbeautydiscounts.com',
  'newproductsforyou.com',
  'affordinginsurance.com',
  'financialsinfo.com',
  'bestpropertyguides.net',
  'savvyfinancetips.net',
  'localhost', 
  'amplifyapp.com',
  'sportshistory.info',
  'jokeoftheday.info',
  'dailyhistoryfacts.org',
  'everydayhealthguide.net'
];

// Default domain to use when no valid domain is found
export const defaultDomain = 'financial-money.com';

// Helper function to validate and get domain
export const getValidDomain = (domain) => {
  if (allowedDomains.includes(domain)) {
    return domain;
  }
  return defaultDomain;
};

// Helper function to check if a domain is allowed
export const isDomainAllowed = (domain) => {
  return allowedDomains.includes(domain);
};

// Helper function to get domain from URL
export const getDomainFromUrl = () => {
  const url = new URL(document.baseURI);
  const hostnameParts = url.hostname.split('.');
  let domain = hostnameParts.length > 2 
    ? hostnameParts.slice(-2).join('.') 
    : url.hostname;

  // Check if we're on localhost or any Amplify domain (ends with amplifyapp.com)
  if (domain === 'localhost' || 
      domain === 'amplifyapp.com' || 
      hostnameParts.includes('amplifyapp') ||
      url.hostname.endsWith('amplifyapp.com')) {
    const params = new URLSearchParams(window.location.search);
    const domainParam = params.get('domain');
    if (domainParam && isDomainAllowed(domainParam)) {
      domain = domainParam;
    } else {
      domain = defaultDomain;
    }
  }

  return getValidDomain(domain);
}; 